import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import '../parts/CommonProgress.css';
import { useInput } from '../../hooks/useInput';
import { useUserContext } from '../../contexts/UserContext';

export const Login: React.FC = () => {
    const navigate = useNavigate();
    const [userId, userIdAttributes] = useInput('');
    const [password, passwordAttributes] = useInput('');
    const [mfa, mfaAttributes] = useInput('');
    const [formError, setFormError] = useState('');
    const [loading, setLoading] = useState<boolean>(false);
    const userContext = useUserContext();
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [endDate, setEndDate] = useState<Date | null>(null);

    const login: React.FormEventHandler<HTMLFormElement> = async (event) => {

        event.preventDefault();

        setFormError('');
        setLoading(true);

        userContext.login(userId, password, mfa, {
            onSuccess: function (navi) {
                console.log('login: userContext.login success');
                console.log('navigate : ' + navi);
                setLoading(false);
                if (navi != null) {
                    navigate('/' + navi);
                } else {
                    console.log('login: userContext.availableFunction failure functionId: null or undefined');
                    setFormError('error');
                }
            },
            onFailure: function (err) {
                console.log('login: userContext.login failure err[' + err + ']');
                setFormError(err);
                setLoading(false);
            }
        });
    };

    // ISO8601形式かどうかチェックする正規表現
    const iso8601Regex = /^(\d{4}-\d{2}-\d{2}([Tt][\d:.+-]*)?|\d{4}-\d{2}|\d{4})$/;
    // 有効なISO8601形式のデータかチェックする
    const isISO8601 = (dateString: string) => {
        if (!iso8601Regex.test(dateString)) {
            return false; 
        }
        const date = new Date(dateString);
        return !isNaN(date.getTime());
    };

    function dateFormatter(date: Date, timeZone: string): string {
        const formatter = new Intl.DateTimeFormat('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hour12: false,
            weekday: 'short',
            timeZone: timeZone
        });
        return formatter.format(date)
    }

    // タイムゾーン表記を変換する
    function timeZoneFormatter(timeZoneIana: string): string {
        const timeZoneText = new Intl.DateTimeFormat('en-US', {
            timeZoneName: 'longGeneric',
            timeZone: timeZoneIana
        }).formatToParts(new Date()).find(part => part.type === 'timeZoneName');
        return timeZoneText ? timeZoneText.value : timeZoneIana
    }

    // ブラウザのタイムゾーンを取得
    const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // タイムゾーン変換
    let startLocal: string = "";
    let endLocal: string = "";
    let startUtc: string = "";
    let endUtc: string = "";

    if (startDate && endDate) {
        startLocal = dateFormatter(startDate, localTimeZone);
        endLocal = dateFormatter(endDate, localTimeZone);
        startUtc = dateFormatter(startDate, 'UTC');
        endUtc = dateFormatter(endDate, 'UTC');
    }

    useEffect(() => {
        userContext.init();
        // メンテナンス時刻を取得
        const fetchMaintenanceTime = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_GATEWAY_ENDPOINT}/maintenance/info`);

                if (!response.ok) {
                    throw new Error('Failed to fetch maintenance info')
                }
                const data = await response.json();
                if (isISO8601(data["startDate"]) && isISO8601(data["endDate"])) {
                    setStartDate(new Date(data["startDate"]));
                    setEndDate(new Date(data["endDate"]));
                }
            } catch (error) {
                console.error(error);
            }
        }
        fetchMaintenanceTime();
    }, []);

    return (
        <div className="Login_content">
            <div className="Login_box">
                <div className="Login_title">
                    <h1>Login</h1>
                </div>
                <form className="Login_form"
                    onSubmit={login}>
                    <div className="Login_item">
                        <div className="Login_label">User ID</div>
                        <input type="text"  {...userIdAttributes} />
                    </div>
                    <div className="Login_item">
                        <div className="Login_label">Password</div>
                        <input type="password" {...passwordAttributes} />
                    </div>
                    <div className="Login_item">
                        <div className="Login_label">MFA Code</div>
                        <input type="text" {...mfaAttributes} />
                    </div>
                    <div className="Login_item">
                        <div className="error">{formError}</div>
                    </div>
                    <div className="Login_buttonGruop">
                        <button type="submit" className="Login_button">
                            Login
                            {
                                loading &&
                                (
                                    <div className="Common_loader"></div>
                                )
                            }
                        </button>
                    </div>
                </form>
                {startDate && endDate && (
                    <div className="Maintenance_Notice">
                        <h2 className="Maintenance_Title">Maintenance Notice</h2>
                        <div className="Maintainance_Sentence">
                            <p className='Maintainance_Sentence'>Thank you for using our services.</p>
                            <p className='Maintainance_Sentence'>We will be conducting system maintenance during the period below. During this time, Chlor-alkali Solutions will be unavailable. We apologize for any inconvenience and thank you for your understanding.</p>
                        </div>
                        <h3 className="Maintenance_SubTitle">Maintenance Period</h3>
                        <div className="period">
                            <p className='Maintainance_Sentence' id="maintenance-time-local">{startLocal} - {endLocal} ({timeZoneFormatter(localTimeZone)})</p>
                            <p className='Maintainance_Sentence' id="maintenance-time-utc">{startUtc} - {endUtc}  (UTC)</p>
                        </div>
                        <p className='Maintainance_Sentence'>*The service will be resumed as soon as the maintenance is completed</p>
                    </div>
                )}
            </div>
        </div>
    );
};